import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  Validators,
  FormGroup,
} from "@angular/forms";

import { ConfirmationService } from "primeng/primeng";

import { InscricaoService } from "./../../../services/inscricao.service";

import { Categoria } from "./../../../models/categoria";
import { Comoconheceu } from "./../../../models/comoconheceu";
import { Deficiencia } from "./../../../models/deficiencia";
import { Escolaridade } from "./../../../models/escolaridade";
import { Estadocivil } from "./../../../models/estadocivil";
import { Racacor } from "./../../../models/racacor";
import { Uf } from "./../../../models/uf";
import { Unidade } from "./../../../models/unidade";
import { Endereco } from "./../../../models/endereco";
import { Classificacao } from "./../../../models/classificacao";

import { CustomValidator } from "../../shared/validators/custom.validator";
import { Observable } from "rxjs/Observable";
import { Util } from "../../shared/util";
import { MessageService } from "primeng/components/common/messageservice";
import { WebPage } from "../../shared/web-page";
import { UnidadeService } from "../../shared/services/unidade.service";
import { ArquivoService } from "../../shared/services/arquivo.service";
import { LgpdService } from "../../../services/lgpd.service";

@Component({
  selector: 'emprego-na-pistainscricao-form',
  templateUrl: "./inscricao-form.component.html",
  styleUrls: ['./inscricao-form.component.css']
})
export class InscricaoFormComponent extends WebPage implements OnInit {
  exibirModalAceiteLGPD: boolean = false;
  confirmouAceiteLGPD: boolean = false;
  listaCategoria: Categoria[];
  listaCategoriaPretendida: Categoria[];
  listaCategoriaPretendidaBackup: Categoria[];
  listaComoconheceu: Comoconheceu[];
  listaDeficiencia: Deficiencia[];
  listaClassificacao: Classificacao[];
  listaEscolaridade: Escolaridade[];
  listaEstadocivil: Estadocivil[];
  listaRacacor: Racacor[];
  listaUf: Uf[];

  unidade = new Unidade();
  endereco = new Endereco();

  isSubmitted = false;
  storedItems;
  uploadUrl: string;
  arquivosToRemove = new FormArray([]);
  isInvalidCEP = false;
  isPrimeiraHabilitacao = false;
  isAdicaoCategoria = false;
  isMotoFrete = false;
  isMudancaCategoria = false;
  isExibirHabilitacaoAtual = false;
  isExibirHabilitacaoPrentendida = false;
  categoriaAtual = '';
  categoriaPretendida = '';

  get ConfirmeEmail() {
    return this.form.get("ConfirmeEmail");
  }
  get Cep() {
    return this.form.get("Cep");
  }
  get DataCnh() {
    return this.form.get("DataCnh");
  }
  get arquivos() {
    return this.form.get("Arquivos") as FormArray;
  }

  public form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private confirmationService: ConfirmationService,
    messageService: MessageService,
    private inscricaoService: InscricaoService,
    private unidadeService: UnidadeService,
    private arquivoService: ArquivoService,
    private lgpdService: LgpdService
  ) {
    super(messageService);

    this.storedItems = JSON.parse(localStorage.getItem("dadosPrincipais"));
    let isCadUnico = this.storedItems.isPossuiCadUnico == 1 ? true : false;
    this.form = fb.group({
      idFase: [this.storedItems.idFase],
      Cpf: [this.storedItems.cpf],
      OfertaPretendida: [this.storedItems.habilitacao],
      IsPossuiCadUnico: [isCadUnico],
      IsPossuiVinculoProfissional:[this.storedItems.isPossuiVinculoProfissional],
      IsPossuiCienciaPenal:[this.storedItems.isPossuiCienciaPenal],
      Nome: ["", [Validators.maxLength(200), Validators.required]],
      Datanascimento: [this.storedItems.dataNascimento],
      Sexo: ["", Validators.required],
      NomeSocial: [""],
      Nomepai: ["", [Validators.maxLength(200), Validators.required]],
      Nomemae: ["", [Validators.maxLength(200), Validators.required]],
      IdUnidade: [""],
      Unidade: [""],
      Rg: ["", [Validators.maxLength(50), Validators.required]],
      Orgao: ["", [Validators.maxLength(100), Validators.required]],
      IdUfOrgao: ["", Validators.required],
      Nacionalidade: ["", [Validators.maxLength(200), Validators.required]],
      Naturalidade: ["", [Validators.maxLength(200), Validators.required]],
      IdRacaCor: ["", Validators.required],
      IdEstadoCivil: ["", Validators.required],
      IdEscolaridade: ["", Validators.required],
      RendaIndividual: [this.storedItems.salario],
      Observacao: ["", Validators.maxLength(500)],
      TelefonePreferencial: ["", Validators.required],
      TelefoneOpcional1: [""],
      TelefoneOpcional2: [""],
      Email: [
        "",
        [
          Validators.minLength(5),
          Validators.maxLength(200),
          Validators.required,
          CustomValidator.EmailValidator,
        ],
      ],
      ConfirmeEmail: [
        "",
        [
          Validators.minLength(5),
          Validators.maxLength(200),
          Validators.required,
          CustomValidator.EmailValidator,
        ],
      ],
      Cep: ["", [Validators.minLength(10), Validators.required]],
      Logradouro: ["", [Validators.maxLength(200), Validators.required]],
      Numero: ["", [Validators.maxLength(50), Validators.required]],
      Complemento: [""],
      Bairro: ["", [Validators.maxLength(200), Validators.required]],
      NumeroCnh: ["", [Validators.maxLength(50)]],
      DataCnh: [""],
      ValidadeCNH: [""],
      IdCategoriaAtual: [""],
      IdCategoriaPretendida: [""],
      IdDeficiencia: ["", Validators.required],
      Arquivos: new FormArray([]),
      Cidade: [""],
      Uf: [""],
    });
    console.log(JSON.stringify(this.form.value));
    this.uploadUrl =
      this.arquivoService.uploadUrl + "termoCompartilhamentoDesempenho";
  }

  ngOnInit() {
    this.isLoading = true;
    Observable.combineLatest(
      this.unidadeService.getListaUf(),
      this.inscricaoService.getListaRacacor(),
      this.inscricaoService.getListaEstadocivil(),
      this.inscricaoService.getListaEscolaridade(),
      this.inscricaoService.getListaComoconheceu(),
      this.inscricaoService.getListaClassificacao(),
      this.inscricaoService.getListaCategoria(),
      this.inscricaoService.getListaDeficiencia(),
      this.unidadeService.getUnidade(this.storedItems.idUnidade)
    )
      .finally(() => (this.isLoading = false))
      .subscribe(
        (combined) => {
          this.listaUf = combined[0] as Uf[];
          this.listaRacacor = combined[1] as Racacor[];
          this.listaEstadocivil = combined[2] as Estadocivil[];
          this.listaEscolaridade = combined[3] as Escolaridade[];
          this.listaComoconheceu = combined[4] as Comoconheceu[];
          this.listaClassificacao = combined[5] as Classificacao[];
          this.listaCategoria = combined[6] as Categoria[];
          this.listaCategoriaPretendida = combined[6] as Categoria[];
          this.listaDeficiencia = combined[7] as Deficiencia[];
          this.unidade = new Unidade(combined[8]);
          this.form.patchValue({
            IdUnidade: this.unidade.idUnidade,
            Unidade: this.unidade.nomeUnidade,
          });
          this.listaCategoriaPretendida = this.listaCategoria;
          this.listaCategoriaPretendidaBackup = this.listaCategoria.filter((c) => {
            if (c.idCategoria != '3db0cf4c-8156-4fbc-b0a0-5fdade55027c') return c;
          });
          this.validarHabilitacao();
        },
        (error) => this.gerenciaErro(error)
      );
  }
  AfterViewInit(){
    console.log('Validar habilitacao...');
    this.validarHabilitacao();
  }
  private validaEmail() {
    if (this.form.get("Email").value !== this.ConfirmeEmail.value) {
      this.messageService.add({
        severity: "warn",
        summary: "Atenção",
        detail: "E-mail incorreto.",
      });
      this.ConfirmeEmail.setValue("");
    }
  }

  getEnderecoByCep() {
    this.endereco.cidade = "";
    this.endereco.logradouro = "";
    this.endereco.bairro = "";
    this.endereco.uf = "";

    this.isLoading = true;
    this.inscricaoService
      .getEnderecoByCep(Util.limpaCep(this.Cep.value), this.unidade.idUf)
      .finally(() => (this.isLoading = false))
      .subscribe(
        (data) => {
          // if (data === 'invalido') {
          //   this.messageService.add({
          //     severity: 'warn',
          //     summary: 'Atenção',
          //     detail: 'O CEP deve ser da mesma UF da Unidade Operacional!'
          //   });
          //   this.Cep.setValue('');
          // } else {
          this.endereco = new Endereco(data);
          this.form.patchValue({
            Cidade: this.endereco.cidade,
            Logradouro: this.endereco.logradouro,
            Bairro: this.endereco.bairro,
            Uf: this.endereco.uf,
            Complemento: this.endereco.complemento,
          });
          console.log('pesquisando cep...');
          this.validarUfCandidato();
          // }
        },
        (error) => this.gerenciaErro(error)
      );
  }
  onOptionsSelected(event){
    const value = event.target.value;
    this.categoriaAtual = value
    console.log('Backup' + JSON.stringify(this.listaCategoriaPretendidaBackup));
    if (this.isAdicaoCategoria){
      switch (this.categoriaAtual){
        case '27c938ea-bc42-40fd-948f-d1238d710751': //A
        this.listaCategoriaPretendida = this.listaCategoriaPretendidaBackup.filter(
          (c) => c.idCategoria == '4b3b98b5-6dda-492e-afbd-fbaab06e01e2'
        )
        break;
        case '4b3b98b5-6dda-492e-afbd-fbaab06e01e2': //B
          this.listaCategoriaPretendida = this.listaCategoriaPretendidaBackup.filter(
            (c) => c.idCategoria == '27c938ea-bc42-40fd-948f-d1238d710751'
          )
        break;
        default:
          break;
      }
    }else{
      console.log('Mudança...');
      switch (this.categoriaAtual){
        case '4b3b98b5-6dda-492e-afbd-fbaab06e01e2': //B
        this.listaCategoriaPretendida = this.listaCategoriaPretendidaBackup.filter(
          (c) => {
            if(c.idCategoria == '3db0cf4c-8156-4fbc-b0a0-5fdade55027c' ||
            c.idCategoria == '3dc4fd04-a088-486a-8f45-f85b6d7f96b3' ||
            c.idCategoria == '6c388665-75f3-44d0-ad2c-301f76e51b0b'){
              return c;
            };
          }
        )
        break;
        case '3db0cf4c-8156-4fbc-b0a0-5fdade55027c': //C
          this.listaCategoriaPretendida = this.listaCategoriaPretendidaBackup.filter(
            (c) => {
              if(c.idCategoria == '3dc4fd04-a088-486a-8f45-f85b6d7f96b3' || c.idCategoria == '6c388665-75f3-44d0-ad2c-301f76e51b0b'){
                return c;
              };
            }
          )
        break;
        case '3dc4fd04-a088-486a-8f45-f85b6d7f96b3': //D
          this.listaCategoriaPretendida = this.listaCategoriaPretendidaBackup.filter(
            (c) => c.idCategoria == '6c388665-75f3-44d0-ad2c-301f76e51b0b'
          )
        break;
        default:
          this.listaCategoriaPretendida = [];
          break;
      }
    }
  }
  validarHabilitacao(){
    console.log('Habilitacao atual: ' + this.storedItems.habilitacao);
    console.log(JSON.stringify(this.listaCategoria));
    switch(this.storedItems.habilitacao){
      case '1':
        console.log('Validou Habilitacao 1 - Primeira A');
        this.isPrimeiraHabilitacao = true;
        this.isAdicaoCategoria = false;
        this.isMudancaCategoria = false;
        this.isMotoFrete = false;
        this.isExibirHabilitacaoAtual = false;
        this.isExibirHabilitacaoPrentendida = true;
        this.listaCategoria = this.listaCategoria.filter(
          (c) => {
            if (c.idCategoria == '27c938ea-bc42-40fd-948f-d1238d710751') return c;
            }
          );
          this.listaCategoriaPretendida = this.listaCategoria;
        break;
      case '2':
        console.log('Validou Habilitacao 2 - Primeira B');
        this.isPrimeiraHabilitacao = true;
        this.isAdicaoCategoria = false;
        this.isMudancaCategoria = false;
        this.isMotoFrete = false;
        this.isExibirHabilitacaoAtual = false;
        this.isExibirHabilitacaoPrentendida = true;
        this.listaCategoria = this.listaCategoria.filter(
          (c) => {
            if (c.idCategoria == '4b3b98b5-6dda-492e-afbd-fbaab06e01e2') return c;
            }
          );
          this.listaCategoriaPretendida = this.listaCategoria;
        break;
      case '3':
        console.log('Validou Habilitacao 3 - Adição Categoria A');
        this.isPrimeiraHabilitacao = false;
        this.isAdicaoCategoria = true;
        this.isMudancaCategoria = false;
        this.isMotoFrete = false;
        this.isExibirHabilitacaoAtual = true;
        this.isExibirHabilitacaoPrentendida = true;
        this.listaCategoria = this.listaCategoria.filter(
          (c) => {
            if (c.idCategoria == '4b3b98b5-6dda-492e-afbd-fbaab06e01e2') return c;
            }
          );
        this.listaCategoriaPretendida = this.listaCategoria;
        break;
      case '4':
        console.log('Validou Habilitacao 4 - Adição Categoria B');
        this.isPrimeiraHabilitacao = false;
        this.isAdicaoCategoria = true;
        this.isMudancaCategoria = false;
        this.isMotoFrete = false;
        this.isExibirHabilitacaoAtual = true;
        this.isExibirHabilitacaoPrentendida = true;
        this.listaCategoria = this.listaCategoria.filter(
          (c) => {
            if (c.idCategoria == '27c938ea-bc42-40fd-948f-d1238d710751') return c;
            }
          );
        this.listaCategoriaPretendida = this.listaCategoria;
        break;
      case '6':
        console.log('Validou Habilitacao 6 - Mudança Categoria D');
        this.isPrimeiraHabilitacao = false;
        this.isAdicaoCategoria = false;
        this.isMudancaCategoria = true;
        this.isMotoFrete = false;
        this.isExibirHabilitacaoAtual = true;
        this.isExibirHabilitacaoPrentendida = true;
        this.listaCategoria = this.listaCategoria.filter(
          (c) => {
            if (c.idCategoria != '27c938ea-bc42-40fd-948f-d1238d710751' && c.idCategoria != '6c388665-75f3-44d0-ad2c-301f76e51b0b') return c;
            }
          );
        this.listaCategoriaPretendida = this.listaCategoriaPretendida.filter(
          (c) => {
            if (c.idCategoria != '27c938ea-bc42-40fd-948f-d1238d710751' && c.idCategoria != '4b3b98b5-6dda-492e-afbd-fbaab06e01e2') return c;
            }
          );
          this.listaCategoriaPretendidaBackup = this.listaCategoriaPretendida;
        break;
      case '7':
        console.log('Validou Habilitacao 7 - Mudança Categoria E');
        this.isPrimeiraHabilitacao = false;
        this.isAdicaoCategoria = false;
        this.isMudancaCategoria = true;
        this.isMotoFrete = false;
        this.isExibirHabilitacaoAtual = true;
        this.isExibirHabilitacaoPrentendida = true;
        this.listaCategoria = this.listaCategoria.filter(
          (c) => {
            if (c.idCategoria != '27c938ea-bc42-40fd-948f-d1238d710751' && c.idCategoria != '6c388665-75f3-44d0-ad2c-301f76e51b0b') return c;
            }
          );
        this.listaCategoriaPretendida = this.listaCategoriaPretendida.filter(
          (c) => {
            if (c.idCategoria != '27c938ea-bc42-40fd-948f-d1238d710751' && c.idCategoria != '4b3b98b5-6dda-492e-afbd-fbaab06e01e2') return c;
            }
          );
          this.listaCategoriaPretendidaBackup = this.listaCategoriaPretendida;
        break;
      case '8':
        console.log('Validou Habilitacao 8 - Curso de Capacitação de Motofretista');
        this.isPrimeiraHabilitacao = false;
        this.isAdicaoCategoria = false;
        this.isMudancaCategoria = false;
        this.isMotoFrete = true;
        this.isExibirHabilitacaoAtual = true;
        this.isExibirHabilitacaoPrentendida = false;
        this.listaCategoria = this.listaCategoria.filter(c => c.idCategoria === '27c938ea-bc42-40fd-948f-d1238d710751');
        break;
      default:
        break;
    }
    console.log(JSON.stringify(this.listaCategoria));
  }
  validarDataHabilitacao(){
    var data = this.form.controls['DataCnh'].value; // pega o valor do input
    var habilitacaoAtual = this.form.controls['IdCategoriaAtual'].value;
    var habilitacaoPretendida = this.form.controls['IdCategoriaPretendida'].value;;

     data = data.replace(/\//g, "-"); // substitui eventuais barras (ex. IE) "/" por hífen "-"
     var data_array = data.split("-"); // quebra a data em array

     // para o IE onde será inserido no formato dd/MM/yyyy
     if(data_array[0].length != 4){
        data = data_array[2]+"-"+data_array[1]+"-"+data_array[0]; // remonto a data no formato yyyy/MM/dd
     }

     // comparo as datas e calculo a idade
     var hoje = new Date();
     var nasc  = new Date(data);
     var idade = hoje.getFullYear() - nasc.getFullYear();
     console.log(idade);
     var m = hoje.getMonth() - nasc.getMonth();
     if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;

    switch (habilitacaoPretendida){
    case '27c938ea-bc42-40fd-948f-d1238d710751': //A

    break;
    case '4b3b98b5-6dda-492e-afbd-fbaab06e01e2': //B

    break;
    case '3db0cf4c-8156-4fbc-b0a0-5fdade55027c': //C

    break;
    case '3dc4fd04-a088-486a-8f45-f85b6d7f96b3': //D

    break;
    case '6c388665-75f3-44d0-ad2c-301f76e51b0b': //E

    break;
    default:
      break;
    }
     // se for maior que 60 não vai acontecer nada!
     return false;
   }
  validarUfCandidato(){

    console.log(JSON.stringify(this.endereco));
    if (this.endereco.uf === undefined || this.endereco.uf === null || this.endereco.uf != 'SC') {
      //alert('O programa EmpregoNaPista é exclusivo para residentes no estado de Santa Catarina.');
      this.messageService.add({
        severity: "error",
        summary: "Atenção",
        detail: "Endereço não pertence a Santa Catarina!",
      })
      this.isInvalidCEP = true;
    }else{
      this.messageService.add({
        severity: "info",
        summary: "Atenção",
        detail: "Endereço pertence a Santa Catarina.",
      })
      this.isInvalidCEP = false;
    }
  }
  validaCnh() {
    this.isLoading = true;
    this.inscricaoService
      .validaCnh(this.DataCnh.value)
      .finally(() => (this.isLoading = false))
      .subscribe(
        (result) => {
          if (result === "invalido") {
            this.messageService.add({
              severity: "warn",
              summary: "Atenção",
              detail:
                "O candidato não possui o tempo mínimo de habilitação exigida pelo Contran.",
            });
            this.DataCnh.setValue("");
          }
        },
        (error) => this.gerenciaErro(error)
      );
  }

  submit() {

    this.isSubmitted = true;
    if (this.form.invalid) {
      this.messageService.add({
        severity: "warn",
        summary: "Atenção",
        detail: "Campo obrigatório não preenchido!",
      });
      console.log(JSON.stringify(this.form));
      return;
    }
    console.log(JSON.stringify(this.form.value));
    // if (this.arquivos.value.length === 0) {
    //   this.messageService.add({
    //     severity: "warn",
    //     summary: "Atenção",
    //     detail:
    //       "Campo <b>Termo de Compartilhamento de Desempenho</b> obrigatório não preenchido!",
    //   });
    //   return;
    // }
    if (!this.confirmouAceiteLGPD) {
      this.exibirModalAceiteLGPD = true;
      return;
    }
    this.confirmationService.confirm({
      message: "Deseja enviar os dados digitados?",
      header: "Confirmação",
      icon: "fa fa-question-circle",
      accept: () => {
        this.isLoading = true;
        const idSistema = "86157F74-BDEC-4BA4-ADEE-A0B144B3C6D6";
        this.lgpdService
          .aceitarTermoUsuario({
            idTipoAcao: "444B0C2C-8AA1-444F-8FA5-4600982FCAF8",
            idTipoTermo: "2A98616B-C722-435F-8B47-03DCA1136AA5",
            idSistema,
            cpf: this.form.get("Cpf").value.replace('.', '').replace('.','').replace('-', ''),
          })
          .subscribe(
            () => {
              this.lgpdService
                .aceitarTermoUsuario({
                  idTipoAcao: "8995D223-9859-43EF-B34E-ACB62F832A23",
                  idTipoTermo: "9EAB7BC0-CA18-4151-B0EA-9093DD3FF983",
                  idSistema,
                  cpf: this.form.get("Cpf").value.replace('.', '').replace('.','').replace('-', ''),
                })
                .subscribe(
                  () => {
                    this.inscricaoService
                      .inserirCandidato(this.form.value)
                      .finally(() => (this.isLoading = false))
                      .subscribe(
                        (result) => {
                          // localStorage.setItem(
                          //   "mensagem",
                          //   "Inscrição realizada com sucesso! A comprovação da inscrição será encaminhada para o e-mail cadastrado."
                          // );
                          this.exibirModalAceiteLGPD = false;
                          localStorage.removeItem("dadosPrincipais");
                          let mensagem = "...";
                          let ofertaSelecionada = "...";
                          let documentosAviso = "<strong>Relação de Documentos, caso seja convocado:</strong><br>";
                          if(this.isPrimeiraHabilitacao = true){
                            ofertaSelecionada = "Primeira Habilitação";
                            mensagem = documentosAviso + "1.Comprovante de residência <br> 2.Comprovante de inscrição no CADUNICO <br> 3.Carteira de Identidade";
                          }
                          if(this.isAdicaoCategoria = true){
                            ofertaSelecionada = "Adição de Categoria A/B"
                            mensagem = documentosAviso + "1.Comprovante de residência <br> 2.CNH <br> 3.Comprovante de inscrição no CADUNICO <br> 4.Comprovante de inscrição de sindicato ou associação profissional.";
                          }
                          if(this.isMudancaCategoria = true){
                            ofertaSelecionada = "Mudança de Categoria";
                            mensagem = documentosAviso + "1.Comprovante de residência <br> 2.CNH <br> 3.Nada consta do DETRAN <br> 4.Comprovante de inscrição de sindicato ou associação profissional.";
                          }
                          if(this.isMotoFrete = true){
                            ofertaSelecionada = "Curso Motofrete";
                            mensagem = documentosAviso + "1.Comprovante de residência <br> 2.CNH <br> 3.Nada consta do DETRAN <br> 4.Comprovante de inscrição de sindicato ou associação profissional.";
                          }

                          this.messageService.add({
                            severity: "success",
                            summary: "Confirmação",
                            detail: "Inscrição realizada com sucesso! A comprovação da inscrição será encaminhada para o e-mail cadastrado.",
                          });

                          this.confirmationService.confirm({
                            message: mensagem,
                            header: ofertaSelecionada,
                            acceptLabel: "OK",
                            rejectVisible: false,
                            accept: () => {
                              this.router.navigate([
                                "/termo-aceite/" + this.form.value.idFase,
                              ]);
                            },
                            reject:() => {}
                          });
                        },(error) => {
                          this.messageService.add({
                            severity: "error",
                            summary: "Alerta!",
                            detail: "Inscrição não realizada! Favor acionar o administrador do sistema."
                          })
                      }
                      );
                  },
                  (error) =>
                    this.gerenciaErro(
                      "Ocorreu um erro ao aceitar o termo de uso de imagem e voz."
                    )
                );
            },
            (error) =>
              this.gerenciaErro(
                "Ocorreu um erro ao aceitar o termo de privacidade."
              )
          );
      },
      reject: () => {
        this.messageService.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Dados não enviados!",
        });
      },
    });
  }

  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld,
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }

  uploadError(mensagem) {
    this.messageService.add({
      severity: "warn",
      summary: "Atenção",
      detail: mensagem,
    });
    this.isLoading = false;
  }
  onFecharModal(evento: any) {
    console.log("caiu");
    if (evento.confirmado) {
      this.exibirModalAceiteLGPD = false;
      this.confirmouAceiteLGPD = true;
      this.submit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/inscricao-form/inscricao-form.component.ts